import { getRegisterFunction } from '../../utils/register.js';
import { OneUxBarChartElement } from './OneUxBarChartElement.js';
export const register = getRegisterFunction(OneUxBarChartElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-bar-chart': OneUxBarChartElement;
    "bar-chart-a051665cfb9393e41f14305cb66d7e78": OneUxBarChartElement;
  }
}